import { PageNotFound as NotFound, RemoveSplash } from "@mnemonic/mui";
import { ArgusUtils } from "@mnemonic/pure-utils";

const PageNotFound = () => (
  <div style={{ marginTop: "64px" }}>
    <RemoveSplash />
    <NotFound contact={ArgusUtils.getMetaInfo().email} />
  </div>
);

export default PageNotFound;
